(() ->
  matchAllProps = (item, props) ->
    for key, value of props
      prop = item[key]
      if prop == undefined || !isEqual(prop, value)
        return false
    true

  findItemAndIndexByProps = (array, props) ->
    for item, index in array
      if matchAllProps(item, props)
        return {item, index}
    null

  findItemAndIndexById = (array, id) ->
    findItemAndIndexByProps array, id: id

  Array.prototype._find = Array.prototype.find

  isEqual = (prop, value) ->
    return true if prop == value
    if prop instanceof Object && value instanceof Object
      return isObjectsEqual(prop, value)
    false

  isObjectsEqual = (prop, value) ->
    JSON.stringify(prop) == JSON.stringify(value)

  Array.prototype.find = (query) ->
    switch typeof query
      when 'number'
        @_find (i) ->
          i.id == query

      when 'object'
        findItemAndIndexByProps @, query

      else
        @_find query

  Array.prototype.findIndex = (query) ->
    result = switch typeof query
      when 'number'
        findItemAndIndexById @, query

      else
        findItemAndIndexByProps @, query

    return result.index if result
    -1

  Array.prototype.remove = (query) ->
    result = switch typeof query
      when 'number'
        findItemAndIndexById @, query

      else
        findItemAndIndexByProps @, query

    if result
      @splice(result.index, 1)
      true

  Array.prototype.replaceById = (object) ->
    index = @findIndex(object.id)
    @splice(index, 1, object) if index >= 0

  Array.prototype.findWithIndexByProps = (props={}) ->
    findItemAndIndexByProps @, props

  Array.prototype.removeByProps = (props={}) ->
    result = @findWithIndexByProps props
    @splice(result.index, 1) if result

  Array.prototype.findByProps = (props={}) ->
    result = @findWithIndexByProps props
    result.item if result

  Array.prototype.findIndexByProps = (props={}) ->
    result = @findWithIndexByProps props
    return result.index if result

    -1

  Array.prototype.last = ->
    @[@.length - 1]

  Array.prototype.sortByKey = (key) ->
    @sort (a,b) ->
      if a[key] < b[key]
        -1
      else if a[key] > b[key]
        1
      else
        0
)()



// WEBPACK FOOTER //
// ./src/prototypes/array.coffee